import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../CSS/comments.css';
import Addcomment from '../Services/AddComment';
import { useGetComments } from '../Utlis/useFetchData';

const commentFormat = {
  PostKey: '',
  author: 'reader',
  comments: ''
};

function Comments({ postid }) {
  const { data: CommentData, error: commentError, loading } = useGetComments(postid);
  const [comment, setComment] = useState(commentFormat);

  function formatDate(timestamp) {
    const date = new Date(timestamp);
    return date.toISOString().split('T')[0];
  }

  async function handleCommentSubmit(event) {
    event.preventDefault();
    const newComment = { ...comment, PostKey: postid };

    try {
      const response = await Addcomment(newComment);
      const responseData = await response.json();
      alert(`Comment added: ${responseData.message || JSON.stringify(responseData)}`);
      setComment(commentFormat);
    } catch (error) {
      console.error("Error submitting comment:", error);
      alert("There was an error submitting your comment. Please try again.");
    }
  }

  return (
    <div className="CommentMainWrap">
      <form onSubmit={handleCommentSubmit}>
        <label className="CommentLabelTag" htmlFor="Commentbox">Comments</label>
        <input
          className="CommentBoxTag"
          name="Commentbox"
          type="text"
          value={comment.comments}
          onChange={(e) => setComment({ ...comment, comments: e.target.value })}
        />
        <button className="CommentBtnTag" type="submit">Submit</button>
      </form>

      {loading && <p>Loading comments...</p>}
      {commentError && <p>Error loading comments: {commentError.message}</p>}
      {CommentData && CommentData.map((value, index) => {
        const username = value.author.split('@')[0];
        const Userprofile = username.charAt(0).toUpperCase();
        return (
          <div className="CommentShowTag" key={value.id || index}>
            <div className="UsernameWrap">
              <div className="Userprofile">{Userprofile}</div>
              <div className="Username">{username}</div>
              <div className="timeStamp">{formatDate(value.createdAt)}</div>
            </div>
            <div className="UserComment">{value.comments}</div>
          </div>
        );
      })}
    </div>
  );
}

Comments.propTypes = {
  postid: PropTypes.string.isRequired,
};

export default Comments;
